export function getTaggingFunc( eventCategory, eventAction, eventLabel, drawerType) {
  //console.log('drawerType: ', drawerType)
  eventCategory === 'laptop' ? eventCategory = 'desktop' : eventCategory = eventCategory
  const dataLayerInfo = {
    event: 'Content Drawer',
    TGGEventCategory: `Content Drawer ${eventCategory}`,
    TGGEventAction: `${eventCategory.charAt(0).toUpperCase() + eventCategory.slice(1)} ${drawerType ? drawerType + ' ': ''}Drawer ${eventAction} Click`,
    TGGEventLabel: eventLabel
  }
  window.dataLayer.push(dataLayerInfo)
  //console.log(dataLayerInfo)
}
